import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import RotateRight from '../icons/CropImage/RotateRight'
import Tooltip from '../Tooltip'

const useStyles = makeStyles(() => ({
  rotateButtonContainer: {
    position: 'absolute',
    top: 12,
    left: 12,
    zIndex: 1,
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.15s ease',
    '.patient-scan:hover &': {
      opacity: 1,
      pointerEvents: 'auto'
    }
  },
  iconButton: {
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: '#ffffff'
    }
  }
}))

/**
 * Overlay button that rotates the scan video 90° clockwise on each click.
 * Positioned at the top-left corner of the video frame.
 *
 * @prop onClick - fired when the button is clicked.
 */
const RotateVideoButton = ({ onClick = () => {} }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      onClick()
    },
    [onClick]
  )

  return (
    <div className={classes.rotateButtonContainer}>
      <Tooltip value={t('dialogs.scanView.rotateVideo')}>
        <IconButton
          className={classes.iconButton}
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <RotateRight color={isHovered ? '#4451DE' : '#ffffff'} />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export default RotateVideoButton
